import React, { useState, useEffect } from 'react'
import logofedpa from 'src/assets/logofedpa.svg'

// boostrap
import { Col, Image, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// iconos
import { faCarSide, faClipboardCheck, faCopy, faPhone } from '@fortawesome/free-solid-svg-icons'
import iconWhatsapp from 'src/assets/whatsapp.png';

import { CopyToClipboard } from 'react-copy-to-clipboard';


const TheHeader = () => {

    const lineaWhatsapp = ' 6314-7693';
    const lineaTelefonico = '340-5400';

    const [copiedLineaWhatsapp, setCopiedLineaWhatsapp] = useState(false);
    const [copiedLineaTelefonico, setCopiedLineaTelefonico] = useState(false);

    useEffect(() => {

        if (copiedLineaWhatsapp) {
            setTimeout(() => {
                setCopiedLineaWhatsapp(false);
            }, 1000)
        }

    }, [copiedLineaWhatsapp])

    useEffect(() => {

        if (copiedLineaTelefonico) {
            setTimeout(() => {
                setCopiedLineaTelefonico(false);
            }, 1000)
        }

    }, [copiedLineaTelefonico])
    return (
        <header className="App-header text-white shadow pb-2">
            <div className="jumbotron my-4">
                <h1 className="text-uppercase text-center">Directorio Telefonico</h1>
                <Image src={logofedpa} alt="Logo" className="animation-logo App-logo" />
                <hr className='style-one' />
                <h5>FEDPA Asistencia
                    &nbsp;
                    <FontAwesomeIcon icon={faCarSide} />
                </h5>
                <Row className='justify-content-center'>
                    <Col md={1} className='m-0 p-0'>
                        <p>
                            <img src={iconWhatsapp} alt='no tiene' height={20} />
                            {lineaWhatsapp}
                            <CopyToClipboard
                                text={lineaWhatsapp}
                                onCopy={() => setCopiedLineaWhatsapp(true)}
                                style={{ cursor: 'pointer' }}
                                >
                                <span>
                                    <FontAwesomeIcon icon={copiedLineaWhatsapp ? faClipboardCheck : faCopy} size='xs' />
                                </span>
                            </CopyToClipboard>

                        </p>
                    </Col>
                    <Col md={1} className='m-0 p-0'>
                        <p>
                            <FontAwesomeIcon icon={faPhone} color="#C0272D" transform={{ rotate: 150 }} />
                            {lineaTelefonico}
                            <CopyToClipboard
                                text={lineaTelefonico}
                                onCopy={() => setCopiedLineaTelefonico(true)}
                                style={{ cursor: 'pointer' }}>
                                <span>
                                    <FontAwesomeIcon icon={copiedLineaTelefonico ? faClipboardCheck : faCopy} size='xs' />
                                </span>
                            </CopyToClipboard>
                        </p>
                    </Col>
                </Row>

            </div>
        </header>
    )
}

export default TheHeader
